module.exports = __webpack_public_path__ + "static/media/old-computer.c0127d43.png";